import { styled } from '@mui/material';
import { Stack } from "@mui/material";

 export const StyledStack = styled(Stack)`
  flex-direction: row;
  align-items: end;
  flex-basis: 30%;
  flex-grow: 0;

  .MuiFormControl-root {
    margin: 0;
    min-width: 120px;

    .MuiInput-root {
      margin-right: 5px;
    }
  }
`;